import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedName from 'I18n/components/FormattedName'; // @ts-expect-error untyped dependency

import ReferenceName from 'customer-data-reference-ui-components/name/ReferenceName'; // @ts-expect-error untyped dependency

import UnknownName from 'customer-data-reference-ui-components/name/UnknownName'; // @ts-expect-error untyped dependency

import { USER } from 'reference-resolvers/constants/ReferenceObjectTypes'; // @ts-expect-error untyped dependency

import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers'; // @ts-expect-error untyped dependency

import UserReferenceResolver from 'reference-resolvers/resolvers/UserReferenceResolver';
const WorkflowAuthorPropTypes = {
  id: PropTypes.number
};

const WorkflowAuthor = ({
  id
}) => /*#__PURE__*/_jsx(ReferenceName, {
  id: id,
  referenceObjectType: USER,
  onError: () => /*#__PURE__*/_jsx(UnknownName, {
    referenceObjectType: USER
  }),
  onResolved: ({
    reference
  }) => {
    const {
      firstName,
      lastName
    } = reference.referencedObject.toJS();
    return /*#__PURE__*/_jsx(FormattedName, {
      givenName: firstName,
      familyName: lastName
    });
  }
});

WorkflowAuthor.propTypes = WorkflowAuthorPropTypes;
export default ProvideReferenceResolvers({
  [USER]: UserReferenceResolver
}, WorkflowAuthor);